module.exports = __webpack_public_path__ + "static/img/image_solutions_ime_05.7438f0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_ime_05.png
// module id = C4VD
// module chunks = 10